import React, { useState } from 'react'
import iconVisa from 'images/icons/visa.svg'
import iconMastercard from 'images/icons/mastercard.svg'
import iconAmex from 'images/icons/amex.svg'
import Header from '../../Header'
import Very from '../../../helpers/request_wrapper';
import { buttons } from '../../../helpers/const'
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CreditCardForm from "./CreditCardForm";

export default function Index(props) {
  const [ customer, setCustomer ] = useState(props.customer);
  const [ showForm, setShowForm ] = useState(false);
  const { currentUser, countries, stripe_key } = props;
  const stripePromise = loadStripe(stripe_key);
  const [ saving, setSaving ] = useState(false);
  const [ error, setError ] = useState();

  const CountryOptions = countries.map(country => {
    return { label: country.country_data_or_code.name, value: country.country_data_or_code.name }
  });

  const toggleShowForm = () => {
    setShowForm(true)
  };

  const deleteCard = () => {
    setSaving(true);
    setError("Deleting Card Please Wait..");
    Very.delete(`/customers/${customer.id}`).then(res => {
      console.log(res.data);
      setCustomer(res.data)
    }, err => {
      setError(err.data.errors)
    })
  };
  console.log(!customer.default_source && !showForm)
  return (
    <React.Fragment>
      <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
        <Header
          buttonText={buttons.persona.text}
          buttonUrl={buttons.persona.url}
          currentUser={currentUser}
        />

        <div className="col-12 md-px3 py-110 sm-py4" style={{ maxWidth: '380px' }}>
          <h2 className="center title mb-30">Credit Card</h2>

          {customer.default_source &&
            <React.Fragment>
              {customer.card_type === 'Visa' &&
              <div className="bg-bay-of-many mb-30 p-20 pt-50 rounded-6">
                <div className="flex flex-justify mb-50 px-20 sm-block">
                  <img alt="" className="block sm-mb3" src={iconVisa}/>

                  <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
                </div>
              </div>}

              {customer.card_type === 'MasterCard' &&
              <div className="bg-black mb-30 p-20 pt-50 rounded-6">
                <div className="flex flex-justify mb-50 px-20 sm-block">
                  <img alt="" className="block sm-mb3" src={iconMastercard}/>

                  <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
                </div>
              </div>}

              {customer.card_type === 'American Express' &&
              <div className="bg-science-blue mb-30 p-20 pt-50 rounded-6">
                <div className="flex flex-justify mb-50 px-20 sm-block">
                  <img alt="" className="block sm-mb3" src={iconAmex}/>

                  <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
                </div>
              </div>}


              {!saving && customer.default_source ?
                <div className="mb-10">
                  <a
                    className="btn btn--primary btn--primary-wild-sand btn--fs-12 btn--lh-28 col-12 mb-20 mx-auto"
                    style={{width: '160px'}}
                    onClick={deleteCard}
                  >
                    Delete card
                  </a>
                </div>
                :
                <p className="center">{error}</p>
              }
            </React.Fragment>
          }

          {!customer.default_source && !showForm &&
            <a
              className="btn btn--primary btn--fs-13 btn--h-32 md-width-auto mx-auto w-180"
              onClick={toggleShowForm}
            >
              <span>Add Credit Card</span>
            </a>}

          {!customer.default_source && showForm &&
          <Elements stripe={stripePromise}>
            <CreditCardForm customer={customer} CountryOptions={CountryOptions}/>
          </Elements>}

        </div>
      </div>
    </React.Fragment>
  );
}
